<div class="box vw-100 vh-100">
  <div class="box-title title">
    <span class="title-text" mat-dialog-title>Adicionar Contratos</span>
    <div class="title-action action d-flex justify-flex-end">
      <button type="button"
              class="action-btn vw-100 h-34"
              (click)="handleSearchFields()">
        Buscar
      </button>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="box-actions actions vw-100 d-flex pt-20 column-gap-30">
      <div class="actions-select select d-flex flex-1 direction-column justify-center">
        <span class="select-label pb-5 d-flex">
          Beneficiário:
          <div class="ml-4 pointer" role="button" tabindex="0" (click)="resetControlValue('Beneficiary')"
            (keydown.enter)="resetControlValue('Beneficiary')" (keydown.space)="resetControlValue('Beneficiary')">
            <app-svg-icon src="assets/icons/reload-icon.svg"
                          width="14px"
                          height="14px"
                          color="primary"></app-svg-icon>
          </div>
        </span>
        <app-c-select [data]="beneficiaryOpts"
                      placeholder="Selecione"
                      width="100%"
                      formControlName="Beneficiary"></app-c-select>
      </div>
      <div class="actions-select select d-flex flex-1 direction-column justify-center">
        <span class="select-label pb-5 d-flex">
          Banco:
          <div class="ml-4 pointer" role="button" tabindex="0" (click)="resetControlValue('Bank')"
            (keydown.enter)="resetControlValue('Bank')" (keydown.space)="resetControlValue('Bank')">
            <app-svg-icon src="assets/icons/reload-icon.svg"
                          width="14px"
                          height="14px"
                          color="primary"></app-svg-icon>
          </div>
        </span>
        <app-c-select [data]="bankOpts"
                      placeholder="Selecione"
                      width="100%"
                      formControlName="Bank"></app-c-select>
      </div>
      <div class="actions-select select d-flex flex-1 direction-column justify-center">
        <span class="select-label pb-5 d-flex">
          Canal:
          <div class="ml-4 pointer" role="button" tabindex="0" (click)="resetControlValue('Channel')"
            (keydown.enter)="resetControlValue('Channel')" (keydown.space)="resetControlValue('Channel')">
            <app-svg-icon src="assets/icons/reload-icon.svg"
                          width="14px"
                          height="14px"
                          color="primary"></app-svg-icon>
          </div>
        </span>
        <app-c-select [data]="channelOpts"
                      placeholder="Selecione"
                      width="100%"
                      formControlName="Channel"></app-c-select>
      </div>
      <div class="actions-select select d-flex flex-1 direction-column justify-center">
        <span class="select-label pb-5 d-flex">
          Status Contrato:
          <div class="ml-4 pointer" role="button" tabindex="0"
               (click)="resetControlValue('ContractStatus')"
               (keydown.enter)="resetControlValue('ContractStatus')"
               (keydown.space)="resetControlValue('ContractStatus')">
            <app-svg-icon src="assets/icons/reload-icon.svg"
                          width="14px"
                          height="14px"
                          color="primary"></app-svg-icon>
          </div>
        </span>
        <app-c-select [data]="contractOpts"
                      placeholder="Selecione"
                      width="100%"
                      formControlName="ContractStatus"></app-c-select>
      </div>
      <div class="actions-select select d-flex flex-1 direction-column justify-center">
        <span class="select-label pb-5 d-flex">
          Tipo Beneficiário:
          <div class="ml-4 pointer" role="button" tabindex="0"
               (click)="resetControlValue('BeneficiaryType')"
               (keydown.enter)="resetControlValue('BeneficiaryType')"
               (keydown.space)="resetControlValue('BeneficiaryType')">
            <app-svg-icon src="assets/icons/reload-icon.svg"
                          width="14px"
                          height="14px"
                          color="primary"></app-svg-icon>
          </div>
        </span>
        <app-c-select [data]="beneficiaryTypeOpts"
                      placeholder="Selecione"
                      width="100%"
                      formControlName="BeneficiaryType"></app-c-select>
      </div>
    </div>
  </form>
</div>
